import bindAllOfThis from "src/utils/BindThisHelper";

export class PhaserSlider extends Phaser.GameObjects.Container {

    // Boolean to hold the slider's sliding state
    private isSliding: Boolean = false;

    protected pickerImage: Phaser.GameObjects.Image;
    protected background: Phaser.GameObjects.Image;
    protected triangle: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number, width: number, height: number) {
        super(scene, x, y);
        bindAllOfThis(this, PhaserSlider.prototype);

        this.width = width;
        this.height = height;

        this.initialize();
        this.registerEvents();
    }

    static preload(scene: Phaser.Scene) {
        scene.load.image("triangle", require("/src/assets/qci/sprites/triangle.png"));
        scene.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));

        // Construct a circle to slide slider and make it a texture
        var tempGraphic = scene.add.graphics();
        tempGraphic.setDepth(0);
        tempGraphic.lineStyle(1, 0x000000);
        tempGraphic.fillStyle(0x000000);
        tempGraphic.fillEllipse(8, 8, 16, 16);
        tempGraphic.generateTexture("slider-graphic", 16, 16);
        tempGraphic.clear();
        tempGraphic.destroy();
    }

    initialize(): void {
        // Set size to size of background image
        this.setSize(this.width, this.height);

        // Construct Objects
        this.constructObjects();

        // Only after we have set size can we change our scale to fit what was passed in
        this.setDisplaySize(this.width, this.height);

        // Add items to self and self to scene
        this.add(this.background);
        this.add(this.triangle);
        this.add(this.pickerImage);
        this.scene.add.existing(this);
    }

    constructObjects() {
        this.background = this.scene.add.image(0, 0, "pixel");
        this.background.setDisplaySize(this.width, this.height);
        this.background.setDepth(0);
        this.background.setOrigin(0);

        this.triangle = this.scene.add.image(this.background.height / 2, this.background.width / 2 + 34, "triangle");
        this.triangle.setDisplaySize(this.height - 15, this.width - 15);
        this.triangle.setAngle(270);
        this.triangle.setDepth(.5);
        this.triangle.setOrigin(0);

        this.pickerImage = this.scene.add.image(this.triangle.x + 10, this.background.getCenter().y, "slider-graphic");
        this.pickerImage.setDepth(1);

        var ellipse = new Phaser.Geom.Ellipse(this.background.frame.realWidth / 2, this.background.frame.realHeight / 2, 32, 32);
        this.pickerImage.setInteractive(ellipse, Phaser.Geom.Ellipse.Contains);
        this.background.setInteractive();
    }

    registerEvents(): void {
        // Allow just a click on the component to change the value
        this.background.on("pointerdown", (pointer: Phaser.Input.Pointer, x: number, y: number) => {
            if (!this.checkBounds(pointer.x - this.x)) {
                return;
            }
            this.isSliding = true;
            this.pickerImage.x = pointer.x - this.x;
        });
        // Normal sliding events
        this.pickerImage.on("pointerdown", (pointer: Phaser.Input.Pointer, x: number, y: number) => {
            if (!this.checkBounds(pointer.x - this.x)) {
                return;
            }
            this.isSliding = true;
            this.pickerImage.x = pointer.x - this.x;
        });
        this.pickerImage.on("pointermove", (pointer: Phaser.Input.Pointer, x: number, y: number) => {
            if (!this.checkBounds(pointer.x - this.x)) {
                return;
            }
            if (this.isSliding) {
                this.pickerImage.x = pointer.x - this.x;
            }
        });
        this.pickerImage.on("pointerup", (pointer: Phaser.Input.Pointer, x: number, y: number) => {
            this.isSliding = false;
        });
        // Emit value when pointer is released. Include when pointer moves off pickerImage
        this.scene.input.on("pointerup", (pointer: Phaser.Input.Pointer, x: number, y: number) => {
            if(this.isSliding) {
                this.isSliding = false;
                let ratio = (this.pickerImage.x) / (this.triangle.displayHeight);
                this.emit("slide", ratio);
            }
        });
    }

    // Dont slide the pickerimage beyond the triangle
    checkBounds(point: number): boolean {
        if (point < this.triangle.x + 5 || point > this.triangle.x + this.triangle.displayHeight - 5) {
            return false;
        }
        else {
            return true;
        }
    }

    // Determine if the slider is sliding
    getIsSliding(): Boolean {
        return this.isSliding;
    }
}



// WEBPACK FOOTER //
// ./src/games/shared/TriSlider.ts